import React from "react";
import { Breadcrumbs, Button } from "@material-ui/core";
import { Search, PersonAdd } from "@material-ui/icons";
import { MENU_RECETAS } from "../../../utils/constants";
import { RECETAS_MENU_PERMISOS } from "../../../utils/permisos";

const style = {
  root: {
    flexGrow: 1,
  },
};

export const RecetasDigitalesBreadCrumb = ({setActiveBreadcrumb, activeBreadcrumb, 
  validarSoloUnPermiso, permisosUser}) => {

  return (
    <Breadcrumbs style={{ color: "#FAFAFA" }} aria-label="breadcrumb">
      {(validarSoloUnPermiso(
          permisosUser,
          RECETAS_MENU_PERMISOS.INGRESO_RECETAS
        ))
        && (
            <Button
              color={
                activeBreadcrumb === MENU_RECETAS.INGRESO_RECETA
                  ? "default"
                  : "inherit"
              }
              onClick={(e) => {
                setActiveBreadcrumb(MENU_RECETAS.INGRESO_RECETA);
              }}
            >
              <PersonAdd className={style.icon} />
              Ingreso de Receta Digital
            </Button>
      )}
      {validarSoloUnPermiso(
          permisosUser,
          RECETAS_MENU_PERMISOS.HISTORIAL_RECETAS
        ) && (
      <Button
        color={
          activeBreadcrumb === MENU_RECETAS.GESTION_HISTORIAL
            ? "default"
            : "inherit"
        }
        onClick={(e) => {
          setActiveBreadcrumb(MENU_RECETAS.GESTION_HISTORIAL);
        }}
      >
        <Search className={style.icon} />
        Historial de Recetas
      </Button>
      )}
    </Breadcrumbs>
  );
};
